"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeHttpTransport = NodeHttpTransport;
function NodeHttpTransport() {
    throw new Error('NodeHttpTransport is not supported in the browser');
}
//# sourceMappingURL=browser.js.map